<template>
    <div>
        <h2 id="deviceFaultModalTitle" class="modal-heading mb-2">Device problem</h2>
        <p class="mb-2">This device appears to be faulty. Please use another device.</p>
        <p v-if="code" class="mb-4">Error code: <span class="font-weight-bold">{{ code }}</span></p>
        <button @click="$emit('close')" class="btn btn-success btn-lg lg-shadow w-100">Continue</button>
    </div>
</template>

<script>
export default {
    name: 'DeviceFaultModalComponent',

    props: {
        // DEV-xxx support code identifying the fault, quoted by the practitioner when reporting it
        code: {
            type: String,
            default: null
        }
    },

    mounted() {
        // vue-js-modal hardcodes role="dialog" on its own wrapper and exposes no hook for an
        // accessible name, so the heading has to be attached from inside the slot content.
        const dialog = this.$el.closest('[role="dialog"]')
        if(dialog) dialog.setAttribute('aria-labelledby', 'deviceFaultModalTitle')
    }
}
</script>
